export const toClientModel = (model) => {
    var _a, _b;
    const conditions = (model.conditions || []);
    const actions = (model.aoActions || []);
    const splitOutConditions = (items, conditionType, conditionCategory) => items
        .filter((item) => item.conditionType === conditionType && item.conditionCategory === conditionCategory)
        .map((item) => item.conditionCode)
        .sort(); // the sort is important for the e2e tests to eventually provide predictable field values to assert against
    const splitOutActions = (items, category) => items
        .filter((item) => item.actionCategory === category)
        .map((item) => item.actionCode)
        .sort();
    // we transpose specialConditions into a one-to-one field to be edited directly via a field on the form
    const specialConditions = (_a = conditions.filter(item => item.conditionType === "Special" && item.conditionCategory === "First")[0]) === null || _a === void 0 ? void 0 : _a.specialConditions;
    const specialConditionsSecond = (_b = conditions.filter(item => item.conditionType === "Special" && item.conditionCategory === "Second")[0]) === null || _b === void 0 ? void 0 : _b.specialConditions;
    return Object.assign(Object.assign({}, model), { specialConditions,
        specialConditionsSecond, generalConditions: splitOutConditions(conditions, "General", "First"), generalConditionsSecond: splitOutConditions(conditions, "General", "Second"), qualificationConditions: splitOutConditions(conditions, "Qualification", "First"), qualificationConditionsSecond: splitOutConditions(conditions, "Qualification", "Second"), subjectConditions: splitOutConditions(conditions, "Subject-Level", "First"), subjectConditionsSecond: splitOutConditions(conditions, "Subject-Level", "Second"), conditions: undefined, aoActions: splitOutActions(actions, "First"), aoActionsSecond: splitOutActions(actions, "Second"), internalOutcomeReason: model.internalOutcomeReason.map((item) => item.reasonCode).sort() });
};
export const fromClientModel = (model, patch) => {
    if (patch.some(operation => operation.op === "replace" &&
        (operation.path.endsWith("Conditions") || operation.path.endsWith("ConditionsSecond")))) {
        // All condition types go in here, including the replacement codes
        const buildCondition = (conditions, conditionType, conditionCategory) => (conditions || []).map(conditionCode => ({
            conditionCode,
            conditionType,
            conditionCategory,
        }));
        // we transpose specialConditions back from the one-to-one field and into the conditions datastructure
        const specialConditions = model.specialConditions
            ? [
                {
                    conditionCode: "Special",
                    conditionType: "Special",
                    conditionCategory: "First",
                    specialConditions: model.specialConditions,
                },
            ]
            : [];
        const specialConditionsSecond = model.specialConditionsSecond
            ? [
                {
                    conditionCode: "Special",
                    conditionType: "Special",
                    conditionCategory: "Second",
                    specialConditions: model.specialConditionsSecond,
                },
            ]
            : [];
        const allConditions = [
            ...buildCondition(model.generalConditions, "General", "First"),
            ...buildCondition(model.generalConditionsSecond, "General", "Second"),
            ...buildCondition(model.qualificationConditions, "Qualification", "First"),
            ...buildCondition(model.qualificationConditionsSecond, "Qualification", "Second"),
            ...buildCondition(model.subjectConditions, "Subject-Level", "First"),
            ...buildCondition(model.subjectConditionsSecond, "Subject-Level", "Second"),
            ...specialConditions,
            ...specialConditionsSecond,
        ];
        patch = [
            // remove all the composite condition values...
            ...patch.filter(operation => !(operation.op === "replace" &&
                (operation.path.endsWith("Conditions") || operation.path.endsWith("ConditionsSecond")))),
            //... replace with the unified version
            { op: "replace", path: "/conditions", value: allConditions },
        ];
    }
    // XXX: Seriously? We gotta have a better interface than this
    let actionArray = [
        ...model.aoActions.map((actionCode) => ({ actionCode, actionCategory: "First" })),
    ];
    if (model.aoActionsSecond) {
        actionArray = [
            ...actionArray,
            ...model.aoActionsSecond.map((actionCode) => ({
                actionCode,
                actionCategory: "Second",
            })),
        ];
    }
    const aoAction = patch.find(operation => operation.op === "replace" && operation.path === "/aoActions");
    const aoActionSecond = patch.find(operation => operation.op === "replace" && operation.path === "/aoActionsSecond");
    if (actionArray.length > 0 && (aoAction || aoActionSecond)) {
        // remove all the composite action values...
        patch = [
            ...patch.filter(operation => !(operation.op === "replace" && operation.path.startsWith("/aoActions"))),
            //... replace with the unified version
            { op: "replace", path: "/aoActions", value: actionArray },
        ];
    }
    const internalOutcomeReason = patch.find(operation => operation.op === "replace" && operation.path === "/internalOutcomeReason");
    if (internalOutcomeReason) {
        internalOutcomeReason.value = (internalOutcomeReason.value || []).map(reasonCode => ({ reasonCode }));
    }
    return patch;
};
